export const CONNECTION_GAMES = [
  [
    {
      category: "To Tie Together",
      words: ["Knot", "Link", "Fuse", "Unite"],
      difficulty: 1,
    },
    {
      category: "Ends in Jack",
      words: ["Car", "Flap", "Hi", "Black"],
      difficulty: 2,
    },
    {
      category: "All are Cooks",
      words: ["Ratatouille", "Captain", "Tim", "Nigella"],
      difficulty: 3,
    },
    {
      category: "Famous Swiss Things",
      words: ["Knives", "Watches", "Chocolate", "Banks"],
      difficulty: 4,
    },
  ],
];
